module.exports = __webpack_public_path__ + "img/NEXTnet_logo.fc1ac0cb.svg";